module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerThree.a9c7cab.png";